// extracted by mini-css-extract-plugin
export var inline = "_vj-0";